import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Chat: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#333' }) => {
  return (
    /*@ts-ignore*/
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7476 38.4383C23.341 35.5654 27.8048 34.0004 32.4054 34.0004H37.9998C39.1044 34.0004 39.9998 33.105 39.9998 32.0004V10.0004C39.9998 8.89586 39.1044 8.00043 37.9998 8.00043H9.99979C8.89522 8.00043 7.99979 8.89586 7.99979 10.0004V32.0004C7.99979 33.105 8.89522 34.0004 9.99979 34.0004H17.9933V39.8409L19.7476 38.4383ZM9.99988 38.0002C6.68617 38.0002 3.99988 35.314 3.99988 32.0002V10.0002C3.99988 6.68654 6.68617 4.00024 9.99988 4.00024H37.9999C41.3136 4.00024 43.9999 6.68654 43.9999 10.0002V32.0002C43.9999 35.314 41.3136 38.0002 37.9999 38.0002H32.4055C28.7128 38.0002 25.1298 39.2564 22.2455 41.5624L18.8667 44.2637C17.5726 45.2983 15.6848 45.0879 14.6502 43.7938C14.225 43.262 13.9934 42.6014 13.9934 41.9205V38.0002H9.99988ZM12.8528 24.6387C11.9479 24.0053 11.7278 22.7582 12.3613 21.8533C12.9947 20.9484 14.2418 20.7283 15.1467 21.3618C20.4623 25.0827 27.5372 25.0827 32.8528 21.3618C33.7577 20.7283 35.0048 20.9484 35.6382 21.8533C36.2716 22.7582 36.0516 24.0053 35.1467 24.6387C28.4538 29.3237 19.5457 29.3237 12.8528 24.6387Z"
        fill={fill}
      />
    </svg>
  );
};

export default Chat;
